<h1 mat-dialog-title>{{ statusMode ? 'Allowance refund status' : 'Refund allowance to team member' }}</h1>
<div mat-dialog-content>
    <span class="teammembername">{{member.email}}</span>
    <ng-container *ngIf="statusMode; else refundForm">
      <span class="info" *ngIf="reservation.status === 'AWAITING_LIQUIDITY' || reservation.status === 'REQUESTED'; else supportMessage">
        ${{(reservation.amountCents / 100).toFixed(2)}} is reserved for refund and cannot be used by the member.
        Stripe funds are not currently available. Wallit administrators have been notified.
        Please wait until you are contacted before retrying.
      </span>
      <ng-template #supportMessage>
        <span class="info">
          ${{(reservation.amountCents / 100).toFixed(2)}} remains reserved and cannot be used by the member.
          Contact Wallit support before taking further action.
        </span>
      </ng-template>
      <span class="status">Status: {{ getStatusLabel() }}</span>
    </ng-container>
    <ng-template #refundForm>
      <span class="info">The amount you specify will be refunded from this team member's current allowance balance of ${{displayBalance}}. You will be able to approve the refund before it happens.</span>
      <form class="form" *ngIf="form" [formGroup]="form" padding>
            <mat-form-field>
                <mat-label>Amount to refund ($)</mat-label>
                <input type="number" [max]="balance" matInput placeholder="" formControlName="amount">
            </mat-form-field>
      </form>
    </ng-template>
</div>
<div class="buttons" mat-dialog-actions>
    <ng-container *ngIf="statusMode; else refundActions">
      <button *ngIf="canManageReservation()" mat-raised-button class="donebutton" color="primary" (click)="retryClicked()">Retry Refund</button>
      <button *ngIf="canManageReservation()" mat-button color="warn" (click)="cancelRequestClicked()">Cancel Refund Request</button>
      <button mat-button (click)="onDismiss()">Close</button>
    </ng-container>
    <ng-template #refundActions>
      <button mat-raised-button [disabled]="!form.valid" class="donebutton" color="primary" (click)="refundClicked()">Refund Allowance</button>
      <button mat-button (click)="onDismiss()">Cancel</button>
    </ng-template>
</div>
